<template>
  <div class="ambassador-container">
    <section id="sharelinks" class="mw75 center ph4 ph5-ns f45 fw3 lh-copy mb0">
      <div v-if="message.length > 0" id="alert-message" class="w-100 message-container cf mv2 measure-wide center">
        <div class="w-100 signed-up-alert"> 
          {{ message }}
        </div>
      </div>
      <div v-if="page === '/ambassador/'" class="ambassador-left-bottom">
        <!-- <div><strong>{{ user.email }}</strong></div> -->
        <div><ReferredUsers :user="user" class="cf w-100 mv2 pv4 measure-wide center"/></div>
      </div>

      <div class="cf w-100 mv2 mb4-ns mt3-ns pv4">
        <div class="w-100 measure-wide center">
          <Share :user="user" />
        </div>
      </div>


      <div v-if="page === '/ambassador/'" class="ambassador-seperator-seperator">
        <div class="ambassador-seperator"></div>
      </div>
     
      <div class="cf w-100 pb6">
        <div class="w-100 measure-wide center">
          <SendReferral :user="user" />
        </div>
        
      </div>
    </section>
  </div>
</template>

<script>
import ReferredUsers from './ReferredUsers.vue';
import Share from './Share.vue';
import SendReferral from './SendReferral.vue';
import util from '../util.js';
import request from 'request';
import anime from 'animejs'
import 'lodash';

export default {
  name: 'Ambassador',
  components: {
    ReferredUsers,
    Share,
    SendReferral
  },
  data() {
    return {
      message: "",
      page: window.location.pathname,
      user: {
        email: "",
        uid: ""
      }
    }
  },
  methods: {
    fetchUser() {
      let user = this.$cookies.get("userEmail");
      let userid = this.$cookies.get("userId");

      if (!_.isNull(user) && !_.isNull(userid)){
        this.user.email = user;
        this.user.uid = userid;
        return true;
      } else {
        return false;
      }
    },
    fetchMessage() {
        var msg = this.$cookies.get("message");
        if (!_.isNull(msg)){
          if (msg.length > 0){
            this.message = msg;
          }
        }
    },
    setUser(email){
      var self = this;
      var options = {
          url: process.env.HOME_API + "/api/users/email/" + email,
          method: 'GET',
      }

      request(options, function (error, response, body) {
          var json = JSON.parse(body);
          if (json.user.length > 0){
            var bodyUser = json.user[0];

            self.user.email = bodyUser.email;
            self.user.uid = bodyUser.user_id;
            self.$cookies.set("userEmail", bodyUser.email, Infinity);
            self.$cookies.set("userId", bodyUser.user_id, Infinity);
          } else {
            window.location.href = '/';
          }
      });
    },
    animateObjs(){
      var els = document.querySelectorAll('#alert-message');

      var nodeList = anime({
        targets: els,
        translateY: 250
      });

      var allCallbacks = anime({
        targets: els,
        opacity: 0,
        delay: 6000,
        duration: 1000
      });
    }
  },
  mounted() {
    let email = util.getParameterByName("user")

    // If there is an email parameter
    if (!_.isNull(email)) {
      this.setUser(email);
    }

    // Normal flow (no parameter)
    else {
      let userExists = this.fetchUser()
      if (!userExists) window.location.href = '/';
      else this.fetchMessage();
    }
  }
}
</script>



// WEBPACK FOOTER //
// _vue/components/Ambassador.vue